module.exports = __webpack_public_path__ + "img/banner04_01-02.1040d71d.png";